/* -------------------------------------------------------------------------- */
/*                                 Mobile menu                                */
/* -------------------------------------------------------------------------- */
function mobileMenu() {
  var hamBurger = document.getElementById("mobileToggle");

  if (menu.classList.contains("site-header__nav--mobile__menu--open")) {
    menu.classList.remove("site-header__nav--mobile__menu--open");
    hamBurger.classList.remove("is-active");
    bar.classList.remove("site-header__nav--mobile__active");
  } else {
    menu.classList.add("site-header__nav--mobile__menu--open");
    hamBurger.classList.add("is-active");
    bar.classList.add("site-header__nav--mobile__active");
  }
}

document.addEventListener("DOMContentLoaded", function () {
  var hamBurger = document.getElementById("mobileToggle");
  var menu = document.getElementById("mobileMenu");
  var bar = document.getElementById("mobileNav");
  hamBurger.addEventListener("click", function () {
    if (menu.classList.contains("site-header__nav--mobile__menu--open")) {
      menu.classList.remove("site-header__nav--mobile__menu--open");
      hamBurger.classList.remove("is-active");
      bar.classList.remove("site-header__nav--mobile__active");
    } else {
      menu.classList.add("site-header__nav--mobile__menu--open");
      hamBurger.classList.add("is-active");
      bar.classList.add("site-header__nav--mobile__active");
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  var subCheck = document.getElementsByClassName("subcheck");
  var subMenu = document.getElementsByClassName("mobile-menu__sub-menu");

  for (var i = 0; i < subMenu.length; i++) {
    var goBack = document.createElement("LI");
    var goBackNode = document.createTextNode("Terug");
    goBack.classList.add("mobile-menu__sub-menu__back");
    goBack.appendChild(goBackNode);
    subMenu[i].prepend(goBack);
  }

  for (var i = 0; i < subCheck.length; i++) {
    subCheck[i].addEventListener("click", function () {
      if (this.nextElementSibling.classList.contains("sub-menu-active")) {
        this.nextElementSibling.classList.remove("sub-menu-active");
      } else {
        this.nextElementSibling.classList.add("sub-menu-active");
      }
    });
  }

  var backToggle = document.getElementsByClassName(
    "mobile-menu__sub-menu__back"
  );
  for (var i = 0; i < backToggle.length; i++) {
    backToggle[i].addEventListener("click", function () {
      if (this.parentElement.classList.contains("sub-menu-active")) {
        this.parentElement.classList.remove("sub-menu-active");
      } else {
        this.parentElement.classList.add("sub-menu-active");
      }
    });
  }

  // for (var i = 0; i < subCheck.length; i++) {
  // subCheck[i].addEventListener('click', function() {
  //    if(this.nextElementSibling.classList.contains('mobile-menu__sub-menu--1')) {
  //     this.nextElementSibling.classList.add('active-level-1');
  //    }
  //    if(this.nextElementSibling.classList.contains('mobile-menu__sub-menu--2')) {
  //     this.nextElementSibling.classList.add('active-level-2');
  //    }
  // })
  // }

  // for (var i = 0; i < backLevelOne.length; i++) {
  // backLevelOne[i].addEventListener('click', function() {
  //    console.log('clicked!');
  //    if(this.parentElement.classList.contains('active-level-1')) {
  //     this.parentElement.classList.remove('active-level-1');
  //    }
  // })
  // }

  // for (var i = 0; i < backLevelTwo.length; i++) {
  // backLevelTwo[i].addEventListener('click', function() {
  //    console.log('clicked!');
  //    if(this.parentElement.classList.contains('active-level-2')) {
  //     this.parentElement.classList.remove('active-level-2');
  //    }
  // })
  // }
});

/* -------------------------------------------------------------------------- */
/*                                  Lightbox                                  */
/* -------------------------------------------------------------------------- */
document.addEventListener("DOMContentLoaded", function () {
  refreshFsLightbox();
});

/* -------------------------------------------------------------------------- */
/*                                  Sub menu                                  */
/* -------------------------------------------------------------------------- */
document.addEventListener("DOMContentLoaded", function () {
  var subcheck = document.getElementsByClassName("subcheck");

  // for (var i = 0; i < subcheck.length; i++) {
  //   subcheck[i].addEventListener("click", function () {
  //     var parent = this.parentElement;
  //     var subMenu = this.nextElementSibling;
  //     var subMenuChildren = this.nextElementSibling.children.length;
  //     var heightBase = 40;
  //     if (
  //       parent.classList.contains("mobile-menu__item--parent__active") &&
  //       subMenu.classList.contains("mobile-menu__sub-menu--1")
  //     ) {
  //       parent.classList.remove("mobile-menu__item--parent__active");
  //       subMenu.style.height = "0px";
  //     } else if (subMenu.classList.contains("mobile-menu__sub-menu--1")) {
  //       parent.classList.add("mobile-menu__item--parent__active");
  //       subMenu.style.height = heightBase * subMenuChildren + "px";
  //     } else if (
  //       parent.classList.contains("mobile-menu__item--parent__active") &&
  //       subMenu.classList.contains("mobile-menu__sub-menu--2")
  //     ) {
  //       parent.classList.remove("mobile-menu__item--parent__active");
  //       this.parentElement.parentElement.style.height =
  //         heightBase * this.parentElement.parentElement.children.length + "px";
  //       this.nextElementSibling.style.height = "0px";
  //     } else {
  //       this.parentElement.parentElement.style.height =
  //         this.parentElement.parentElement.clientHeight +
  //         heightBase * subMenuChildren +
  //         "px";
  //       this.nextElementSibling.style.height =
  //         heightBase * subMenuChildren + "px";
  //       parent.classList.add("mobile-menu__item--parent__active");
  //     }
  //   });
  // }
});

/* -------------------------------------------------------------------------- */
/*                                Event toggle                                */
/* -------------------------------------------------------------------------- */
document.addEventListener("DOMContentLoaded", function () {
  if (document.getElementsByClassName("dh-event-toggle").length >= 1) {
    var toggle = document.getElementsByClassName("dh-event-toggle");
    for (var i = 0; i < toggle.length; i++) {
      toggle[i].addEventListener("click", function () {
        var parent = this.parentElement.parentElement.parentElement;
        if (parent.classList.contains("dh-events__item--active")) {
          parent.classList.remove("dh-events__item--active");
          this.classList.remove("dh-event-toggle__active");
        } else {
          parent.classList.add("dh-events__item--active");
          this.classList.add("dh-event-toggle__active");
        }
      });
    }
  }
});

/* -------------------------------------------------------------------------- */
/*                         Select placeholder styling                         */
/* -------------------------------------------------------------------------- */
document.addEventListener("DOMContentLoaded", function () {
  if (document.getElementsByClassName("dh-event-select-location").length >= 1) {
    var selectLocation = document.getElementsByClassName(
      "dh-event-select-location"
    );

    var selectDate = document.getElementsByClassName("dh-events__date");

    for (var i = 0; i < selectLocation.length; i++) {
      if (selectLocation[i].value === "") {
        selectLocation[i].classList.add("select-empty");
      }

      selectLocation[i].addEventListener("change", function () {
        if (this.value === "") {
          this.classList.add("select-empty");
        } else {
          this.classList.remove("select-empty");
        }
      });
    }

    for (var i = 0; i < selectDate.length; i++) {
      if (selectDate[i].value === "") {
        selectDate[i].classList.add("select-date-empty");
      }

      selectDate[i].addEventListener("change", function () {
        if (this.value === "") {
          this.classList.add("select-date-empty");
        } else {
          this.classList.remove("select-date-empty");
        }
      });
    }
  }
});

/* -------------------------------------------------------------------------- */
/*                           Collapsable cart toggle                          */
/* -------------------------------------------------------------------------- */
document.addEventListener("DOMContentLoaded", function () {
  if (
    document.getElementsByClassName("dh-cart__item--dive-toggle").length >= 1
  ) {
    var btn = document.getElementsByClassName(
      "dh-cart__item--dive-toggle__btn"
    );
    for (var i = 0; i < btn.length; i++) {
      btn[i].addEventListener("click", function (e) {
        e.preventDefault();
        if (
          this.parentElement.nextElementSibling.classList.contains(
            "active-cart-dive"
          )
        ) {
          this.parentElement.nextElementSibling.classList.remove(
            "active-cart-dive"
          );
          this.classList.remove("active-toggle-cart");
        } else {
          this.parentElement.nextElementSibling.classList.add(
            "active-cart-dive"
          );
          this.classList.add("active-toggle-cart");
        }
      });
    }
  }
});

/* -------------------------------------------------------------------------- */
/*                                  scroller                                  */
/* -------------------------------------------------------------------------- */
//scroller
var debounce = function debounce(fn) {
  var frame;
  return function () {
    for (
      var _len = arguments.length, params = new Array(_len), _key = 0;
      _key < _len;
      _key++
    ) {
      params[_key] = arguments[_key];
    }

    if (frame) {
      cancelAnimationFrame(frame);
    }

    frame = requestAnimationFrame(function () {
      fn.apply(void 0, params);
    });
  };
};

var storeScroll = function storeScroll() {
  document.documentElement.dataset.scroll = window.scrollY;
};

document.addEventListener("scroll", debounce(storeScroll), {
  passive: true,
});
storeScroll(); //eof scroller

/* -------------------------------------------------------------------------- */
/*                                 FAQ Element                                */
/* -------------------------------------------------------------------------- */

document.addEventListener("DOMContentLoaded", function () {
  function setClass(els, className, fnName) {
    for (var i = 0; i < els.length; i++) {
      els[i].classList[fnName](className);
    }
  }

  if (document.getElementsByClassName("hd-content__faq--wrap").length >= 1) {
    var acc = document.getElementsByClassName("hd-content__faq--wrap");
    var panel = document.getElementsByClassName(
      "hd-content__faq--wrap__answer"
    );

    for (var i = 0; i < acc.length; i++) {
      acc[i].addEventListener("click", function (e) {
        e.preventDefault();
        var setClasses = !this.classList.contains(
          "hd-content__faq--wrap__active"
        );
        setClass(acc, "hd-content__faq--wrap__active", "remove");
        setClass(panel, "show", "remove");

        if (setClasses) {
          this.classList.toggle("hd-content__faq--wrap__active");
          this.nextElementSibling.classList.toggle("show");
        }
      });
    }
  }
});

/* -------------------------------------------------------------------------- */
/*                             Update ajax counter                            */
/* -------------------------------------------------------------------------- */
document.addEventListener("DOMContentLoaded", function () {
  if (document.querySelectorAll(".quantity .qty").length >= 1) {
    var quantity = document.querySelectorAll(".quantity .qty");
    var update = document.getElementsByName("update_cart")[0];
    for (var i = 0; i < quantity.length; i++) {
      quantity[i].addEventListener("change", function () {
        var timeOut = setTimeout(function () {
          update.click();
        }, 2000);
      });
    }
  }

  jQuery(function ($) {
    $(document)
      .ajaxStart(function () {})
      .ajaxStop(function () {
        var quantity = document.querySelectorAll(".quantity .qty");
        var update = document.getElementsByName("update_cart")[0];
        for (var i = 0; i < quantity.length; i++) {
          quantity[i].addEventListener("change", function () {
            setTimeout(function () {
              update.click();
            }, 2000);
          });
        }
      });
  });
});

/* -------------------------------------------------------------------------- */
/*                     Disable checkout button when error                     */
/* -------------------------------------------------------------------------- */
document.addEventListener("DOMContentLoaded", function () {
  if (document.getElementsByClassName("woocommerce-error").length >= 1) {
    document.querySelector(".checkout-button").setAttribute("disabled", "");
    document
      .querySelector(".checkout-button")
      .addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
      });
  }
});

function orderBtn() {
  if (document.querySelectorAll(".duikhuis-groep-fields input").length >= 1) {
    var fields = document.querySelectorAll(".duikhuis-groep-fields input");
    var btn = document.getElementById("place_order");
    var orderBtn = document.querySelector(".order-disabled");
    btn.classList.add("order-disabled");

    for (var i = 0; i < fields.length; i++) {
      if (fields[i].value !== "") {
        btn.classList.remove("order-disabled");
      } else if (fields[i].value == "") {
        btn.classList.add("order-disabled");
      }
    }
  }
}

document.addEventListener("DOMContentLoaded", function () {
  orderBtn();

  var fields = document.querySelectorAll(".duikhuis-groep-fields input");
  for (var i = 0; i < fields.length; i++) {
    fields[i].addEventListener("change", function () {
      orderBtn();
    });
  }

  jQuery(function ($) {
    $(document)
      .ajaxStart(function () {})
      .ajaxStop(function () {
        orderBtn();
        var fields = document.querySelectorAll(".duikhuis-groep-fields input");
        for (var i = 0; i < fields.length; i++) {
          fields[i].addEventListener("change", function () {
            orderBtn();
          });
        }
      });
  });
});

/* -------------------------------------------------------------------------- */
/*                          clear post data on click¸                         */
/* -------------------------------------------------------------------------- */
document.addEventListener("DOMContentLoaded", function () {
  jQuery(function ($) {
    $(".dh-event-toggle").on("click", function (e) {
      $.ajax({
        type: "POST",
        url: "/wp-admin/admin-ajax.php",
        dataType: "html",
        data: {
          action: "duikhuis_ajax_clear_post",
        },
        beforeSend: function () {
          //console.log("clearing data...");
        },
        success: function (res) {
          //console.log(res);
        },
      });
    });
  });
});

//sub
